import { NextSeo } from "next-seo"
import { memo } from "react"
import { createImageApiUrl } from "./createImageApiUrl"

export const encodeImageUrl = (
  baseUrl: string,
  params: { [key: string]: string }
): string => {
  // Remove double slashes from the URL path (except for the protocol part)
  const correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1")

  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&")

  return `${correctedBaseUrl}?${queryString}`
}

export const seoKeys = {
  // NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
}
export type SeoKey = keyof typeof seoKeys

for (const key in seoKeys) {
  seoKeys[key] = encodeURIComponent(
    seoKeys[key]
      .replace(/\/\[.+/, "")
      .replace("/", "")
      .replace(/-/g, " ")
  )
}
export interface SeoMetadataWithImage {
  title: string
  description: string
  keywords: string
  image?: { alt: string; imageUrl: string }
  noIndex?: boolean
}

export const emptySeo: SeoMetadataWithImage = {
  title: " ",
  description: "",
  keywords: "",
}

type SeoMetaDataProps = { data: SeoMetadataWithImage | null }

const SeoMetaData = ({ data }: SeoMetaDataProps) => (
  <>
    {data && (
      <NextSeo
        title={data.title}
        description={data.description || ""}
        additionalMetaTags={[
          { name: "title", content: data.title },
          { name: "keywords", content: data.keywords },
          { name: "description", content: data.description },
        ]}
        openGraph={{
          title: data.title,
          description: data.description || "",
          images: data.image
            ? [
                {
                  url: createImageApiUrl(data.image.imageUrl),
                  alt: data.image.alt,
                  width: 1200,
                  height: 630,
                },
              ]
            : [],
        }}
        noindex={data.noIndex}
        nofollow={data.noIndex}
      />
    )}
  </>
)

export default memo(SeoMetaData)
